import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user_name: [],
        user_id: [],
        selectedSong: [],
        playId: [],
        isPittan: [],
        assignmentImg: [],
        firstPittan: [],
        firstAccess: true
    },
    mutations: {
        FETCH_ADD_USER_NAME(state, user_name) {
            state.user_name = user_name
        },
        FETCH_ADD_USER_ID(state, user_id) {
            state.user_id = user_id
        },
        SET_SELECTED_SONG(state, selectedSong) {
            state.selectedSong = selectedSong
        },
        SET_ASSIGNMENT_IMG(state, assignmentImg) {
            state.assignmentImg = assignmentImg
        },
        FETCH_ADD_PLAY(state, playId) {
            state.playId = playId
        },
        SET_ISPITTAN(state, isPittan) {
            state.isPittan = isPittan
        },
        FIRST_PITTAN(state, firstPittan) {
            state.firstPittan = firstPittan
        },
        FIRST_ACCESS(state, firstAccess) {
            state.firstAccess = firstAccess
        }
    },
})



// WEBPACK FOOTER //
// ./src/store/index.js